// DAY-DIRECTSTAFF-2026-11-02 §3: Needs a human -> "72 h+" after the hub's auto-close, with the agents' groups. The agents' "still
// interested?" text (recruiter-agent still-interested.js) writes ONE agent_lead_decisions row before each send: decision
// 'still_interested', reason 'n:<the hand-off id>' (an 8-character prefix or the whole id), lead_id = the person's newest lead.
//   replied  the person wrote back (a candidate message on their thread) AFTER that text -- waiting on us. Any age; on top; never
//            ticked for closing.
//   asked    the text went and they have not answered yet -- not ticked either (closing it now would bury their answer).
//   matt     every other hand-off open 72 h or more -- ticked for "Close N as <reason>" as before (the first 50).
import { overdue72, OLD_HOURS } from './night29';

const s = (v) => (v === null || v === undefined ? '' : String(v).trim());
const t = (iso) => { const x = Date.parse(iso || ''); return Number.isNaN(x) ? null : x; };
const d10 = (v) => { const d = s(v).replace(/\D/g, ''); return d.length === 11 && d[0] === '1' ? d.slice(1) : d.length >= 10 ? d.slice(-10) : ''; };
export const STILL_INTERESTED = 'still_interested';
export const GROUPS = { replied: 'Replied, waiting on us', asked: 'Asked "still interested?" -- waiting for their answer', matt: 'For Matt' };
const CANDIDATE = new Set(['candidate', 'user']);

/** the agents' still-interested marks -> [{ leadId, handoff (id or prefix, lower case), at }] */
export function stillInterestedMarks(decisions = []) {
  return (decisions || []).filter((d) => d && s(d.decision) === STILL_INTERESTED && t(d.created_at) !== null)
    .map((d) => ({ leadId: s(d.lead_id), handoff: s(d.reason).replace(/^n:/, '').toLowerCase(), at: d.created_at }));
}

/**
 * alerts, needs: the rows Needs a human shows; decisions: agent_lead_decisions; refs: message refs ({ conversation_id, role,
 * created_at }); conversations; leads -> { items: [...each with group, mark, repliedAt], counts: { replied, asked, matt } }
 * items: replied (newest reply first), then asked, then matt (oldest first); one row per person in "replied".
 */
export function handoffGroups({ alerts = [], needs = [], decisions = [], refs = [], conversations = [], leads = [], now = Date.now() }) {
  const marks = stillInterestedMarks(decisions);
  const leadById = new Map((leads || []).map((l) => [s(l.id), l]));
  const markOf = (row) => {
    const ids = (row.alertIds || []).map((x) => s(x).toLowerCase());
    return marks.find((m) => m.handoff && ids.some((id) => id === m.handoff || id.startsWith(m.handoff)))
      || (row.leadId ? marks.filter((m) => m.leadId === s(row.leadId)).sort((a, b) => s(a.at).localeCompare(s(b.at)))[0] : null) || null;
  };
  const convsOf = (row) => {
    if (row.conversationId) return new Set([row.conversationId]);
    const lead = row.lead || leadById.get(s(row.leadId));
    const p = d10((lead && lead.phone) || row.phone);
    return new Set(p ? (conversations || []).filter((c) => d10(c.candidate_phone) === p).map((c) => c.id) : []);
  };
  const repliedAfter = (row, mark) => {
    const convs = convsOf(row); const from = t(mark.at);
    const hits = (refs || []).filter((m) => m && convs.has(m.conversation_id) && CANDIDATE.has(s(m.role).toLowerCase()) && (t(m.created_at) ?? -1) > from)
      .map((m) => m.created_at).sort();
    return hits.length ? hits[hits.length - 1] : null;
  };
  const old = overdue72({ alerts, needs, now });
  const oldKeys = new Set(old.map((i) => i.key));
  // every row, any age, to find the replies (the YES hand-offs are new ones)
  const all = [...old,
    ...(alerts || []).filter((r) => !oldKeys.has(`a:${r.key}`)).map((r) => ({ key: `a:${r.key}`, kind: 'alert', row: r, at: r.at, hours: Math.max(0, Math.floor((now - (t(r.at) ?? now)) / 36e5)), name: (r.lead && r.lead.name) || 'An alert' })),
    ...(needs || []).filter((r) => !oldKeys.has(`n:${r.key}`)).map((r) => ({ key: `n:${r.key}`, kind: 'thread', row: r, at: r.lastReplyAt, hours: Math.max(0, Math.floor((now - (t(r.lastReplyAt) ?? now)) / 36e5)), name: r.name || 'A thread' }))];
  const replied = []; const asked = []; const matt = []; const seen = new Set();
  for (const i of all) {
    const mark = markOf(i.row);
    const at = mark ? repliedAfter(i.row, mark) : null;
    if (at) {
      const who = s(i.row.leadId) || i.key;
      if (seen.has(who)) continue;                 // one row per person: the rest of theirs wait with it
      seen.add(who);
      replied.push({ ...i, group: 'replied', mark, repliedAt: at });
    } else if (oldKeys.has(i.key)) (mark ? asked : matt).push({ ...i, group: mark ? 'asked' : 'matt', mark, repliedAt: null });
  }
  replied.sort((a, b) => s(b.repliedAt).localeCompare(s(a.repliedAt)));
  return { items: [...replied, ...asked, ...matt], counts: { replied: replied.length, asked: asked.length, matt: matt.length }, hours: OLD_HOURS };
}
